import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { ThemeContext } from 'styled-components';
import { CallToAction } from '../../../sharedComponents';
import { CallToActionContainer } from '../../styles';

export const HeroModuleCallToAction = ({
  primaryCTAConfig,
  secondaryCTAConfig,
  thirdCTAConfig,
  fourthCTAConfig,
  additionalCallToActions,
  moduleType,
  displayType,
}) => {
  const themeConfig = useContext(ThemeContext);
  const vStyles = themeConfig.module.vStyles;
  const dStyles = themeConfig.module.dStyles;

  const { settings: { primaryLook, secondaryLook } = {} } =
    dStyles.elements?.callToActionContainer || {};

  const { settings: { size } = {} } =
    dStyles.elements?.callToActionContainer?.elements?.callToAction || {};

  const { settings: { mode } = {} } =
    vStyles.elements?.callToActionContainer?.elements?.callToAction || {};

  const showAdditionalCTAs = Boolean(additionalCallToActions);

  return (
    <CallToActionContainer data-testid="hero-module-call-to-action-container">
      {primaryCTAConfig?.shown && (
        <CallToAction
          look={primaryLook}
          mode={mode}
          size={size}
          ctaConfig={primaryCTAConfig}
          ga4={{
            module_type: moduleType,
            cta_type: 'primary',
            cta_hero_type: displayType,
          }}
        />
      )}
      {secondaryCTAConfig?.shown && (
        <CallToAction
          look={secondaryLook}
          mode={mode}
          size={size}
          ctaConfig={secondaryCTAConfig}
          ga4={{
            module_type: moduleType,
            cta_type: 'secondary',
            cta_hero_type: displayType,
          }}
        />
      )}
      {showAdditionalCTAs && thirdCTAConfig?.shown && (
        <CallToAction
          look={primaryLook}
          mode={mode}
          size={size}
          ctaConfig={thirdCTAConfig}
          ga4={{
            module_type: moduleType,
            cta_type: 'additional_1',
            cta_hero_type: displayType,
          }}
        />
      )}
      {showAdditionalCTAs && fourthCTAConfig?.shown && (
        <CallToAction
          look={secondaryLook}
          mode={mode}
          size={size}
          ctaConfig={fourthCTAConfig}
          ga4={{
            module_type: moduleType,
            cta_type: 'additional_2',
            cta_hero_type: displayType,
          }}
        />
      )}
    </CallToActionContainer>
  );
};

HeroModuleCallToAction.propTypes = {
  primaryCTAConfig: PropTypes.object,
  secondaryCTAConfig: PropTypes.object,
  thirdCTAConfig: PropTypes.object,
  fourthCTAConfig: PropTypes.object,
  additionalCallToActions: PropTypes.bool,
  moduleType: PropTypes.string,
  displayType: PropTypes.string,
};
